import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { convertToVehicleKindDisplayString, Vehicle } from 'types';

type Props = {
  vehicle: Vehicle;
  onClickEdit: (vehicle: Vehicle) => void;
  onClickDelete: (vehicle: Vehicle) => void;
};

const VehicleCard: React.FC<Props> = ({
  vehicle,
  onClickEdit,
  onClickDelete,
}) => (
  <Grid item xs={6} md={6} lg={6}>
    <Card sx={{ maxWidth: 400 }}>
      <CardHeader title={vehicle.name} />
      <CardMedia component="img" height="194" image={vehicle.image || ''} />
      <CardContent>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography style={{ fontWeight: 600 }}>種別</Typography>
              </TableCell>
              <TableCell>
                {convertToVehicleKindDisplayString(vehicle.kind)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography style={{ fontWeight: 600 }}>総走行距離</Typography>
              </TableCell>
              <TableCell>
                {vehicle.total_mileage.toLocaleString('ja-JP')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography style={{ fontWeight: 600 }}>
                  平均燃費(km/L)
                </Typography>
              </TableCell>
              <TableCell>
                {vehicle.average_fuel_consumption.toLocaleString('ja-JP')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography style={{ fontWeight: 600 }}>
                  予想稼働距離(km)
                </Typography>
              </TableCell>
              <TableCell>
                {vehicle.forecast_work_mileage.toLocaleString('ja-JP')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography style={{ fontWeight: 600 }}>
                  予想次回給油総走行距離(km)
                </Typography>
              </TableCell>
              <TableCell>
                {vehicle.forecast_next_refuel_total_mileage.toLocaleString(
                  'ja-JP',
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions>
        <Button variant="contained" onClick={() => onClickEdit(vehicle)}>
          編集
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => onClickDelete(vehicle)}
        >
          削除
        </Button>
      </CardActions>
    </Card>
  </Grid>
);

export default VehicleCard;
